// iOS Safari 에서 일부 버튼의 단일 탭 click 이 억눌리는 문제(더블탭만 먹힘) 우회.
// 버튼에 {...tapClickProps} 로 부착하면, 탭(작은 이동)일 때 touchend 에서 click 을 직접 트리거하고
// 뒤따르는 native click 은 억제(중복 방지). 손가락 이동이 크면(스크롤/드래그) 무시.
export const tapClickProps = {
  onTouchStart: (e) => {
    const t = e.touches && e.touches[0];
    if (t) {
      e.currentTarget.dataset.sx = t.clientX;
      e.currentTarget.dataset.sy = t.clientY;
    }
  },
  onTouchEnd: (e) => {
    const t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    const sx = parseFloat(e.currentTarget.dataset.sx || '0');
    const sy = parseFloat(e.currentTarget.dataset.sy || '0');
    if (Math.abs(t.clientX - sx) > 14 || Math.abs(t.clientY - sy) > 14) return; // 드래그면 무시
    if (e.cancelable) e.preventDefault(); // 뒤따르는 native click 억제(중복 방지)
    const btn = e.currentTarget;
    // 눌린 효과를 잠깐 보여준 뒤 실행 — click 을 즉시 부르면 주문이 순식간에 완료돼
    // 버튼 press 효과(:active scale)가 안 보이던 문제 보완.
    btn.style.transform = 'scale(0.92)';
    setTimeout(() => {
      try { btn.style.transform = ''; } catch (_) { /* noop */ }
      btn.click(); // 프로그램적 click → onClick 확실히 실행
    }, 130);
  },
};
